import React, { useState, useEffect, Fragment } from "react";
import { Card, Button, Form, Alert, Col, Row, Spinner } from "react-bootstrap";
import axios from "axios";
import CountdownTimer from "../components/CountdownTimer";
import { virtual_countries } from "../components/virtual_countries";

const VirtualCardsReloadable = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    middlename: "",
    address_line1: "",
    address_line2: "",
    city: "",
    state: "",
    country: "",
    zip: "",
    phone: "",
    email: "",
    birth_date: "",
    genderId: "",
    pod: "",
    occupation: "",
    nationality: "",
  });

  const [alert, setAlert] = useState(null);
  const [validated, setValidated] = useState(false);
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [countdown, setCountdown] = useState(null);
  const [initialLoadSubmitted, setInitialLoadSubmitted] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [depositDetails, setDepositDetails] = useState(null);
  const [localUser, setLocalUser] = useState(
    JSON.parse(localStorage.getItem("user")) || null
  );
  const [step, setStep] = useState(1); // Step 1: Choose plan, Step 2: Submit KYC, Step 3: Top-up
  const [network, setNetwork] = useState(null);
  const [isLoadingNetwork, setIsLoadingNetwork] = useState(false);
  const [isLoadingTransaction, setIsLoadingTransaction] = useState(false);
  const [isLoadingKYC, setisLoadingKYC] = useState(false);
  const [createdKYCLink, setCreatedKYCLink] = useState(""); // Store the generated KYC link

  const [addressIn, setAddressIn] = useState("");
  const [createdAddress, setCreatedAddress] = useState("");
  const [qrCode, setQrCode] = useState("");
  const [txnHash, setTxnHash] = useState("");
  const [confirmations, setConfirmations] = useState(0);
  const [transactionsConfirmed, setTransactionsConfirmed] = useState(false);
  const [errormessage, setErrorMessage] = useState("");
  const [kycstatus, setkycstatus] = useState("Not Verified");
  const [loadAmount, setloadAmount] = useState(0);

  const [pageLoading, setpageLoading] = useState(true);
  const [loadingIssue, setloadingIssue] = useState(false);

  useEffect(() => {
    if (localUser?.virtual_date) {
      const countdownTime =
        new Date(localUser.virtual_date).getTime() + 24 * 60 * 60 * 1000;
      const now = new Date().getTime();
      if (countdownTime > now) {
        console.log("Set Countdown", countdownTime);
        setCountdown(countdownTime);
      } else {
        console.log("Countdown null");
        setCountdown(1);
      }
    }
    if (localUser?.virtual_type) {
      console.log("Set step2");
      setStep(2);
    }
    if (localUser?.virtual_chid) {
      console.log("Set step2");

      let apiUrl =
        "https://dashboard.croesus-asset.management/api/virtual-cards/check-card-holder-status";
      let requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization:
            "Bearer PtuvxLhFoAAudqR13uhbDNect4UQNqD1kWDz0SYkLhQwDzNcNREgHuVLApSg",
        },
        body: JSON.stringify({
          cardHolderId: localUser?.virtual_chid,
        }),
      };

      fetch(apiUrl, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.success) {
            console.log("handle success", result.message);
            if (result.message == 0) {
              setkycstatus("Not Verified");
              setpageLoading(false);
            } else {
              setkycstatus("Verified");
              setpageLoading(false);
            }
          } else {
            console.log("handle error", result.message);
            // handle error
          }
        })
        .catch((error) => console.log("Error:", error));

      setStep(3);
    } else {
      setpageLoading(false);
    }

    if (localUser?.virtual_chid) {
      setCreatedKYCLink(localUser?.kyc_url);
    }
  }, [localUser]);

  const vipModel = { name: "VIP", amount: 50, fee: "3.49% + 3 USD" };
  const premiumModel = { name: "Premium", amount: 142, fee: "3.99% + 4 USD" };
  const standardModel = { name: "Standard", amount: 4, fee: "4.99% + 5 USD" };

  let pricingModels = [vipModel, premiumModel, standardModel]; // Default value

  if (localUser?.cards?.card_type == 1) {
    pricingModels = [standardModel];
  } else if (localUser?.cards?.card_type == 2) {
    pricingModels = [premiumModel];
  } else if (localUser?.cards?.card_type == 3) {
    pricingModels = [vipModel];
  }

  const handlePlanSelection = (plan) => {
    setSelectedPlan(plan);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData({
        ...formData,
        kycImage: reader.result,
      });
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setisLoadingKYC(true);
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      setisLoadingKYC(false);
      return;
    }

    setValidated(true);

    try {
      // Step 1: Submit form data to the external API
      const externalApiResponse = await axios.post(
        "https://dashboard.croesus-asset.management/api/virtual-cards/create-card-holder-virtual",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer PtuvxLhFoAAudqR13uhbDNect4UQNqD1kWDz0SYkLhQwDzNcNREgHuVLApSg`,
          },
        }
      );

      if (externalApiResponse.data.success) {
        console.log("KYC submitted successfully", externalApiResponse.data);
        const cardholderID = externalApiResponse.data.message;
        const virtual_date = new Date().toISOString();
        const kycLink = externalApiResponse.data.sumsub_link;

        // Update local user data
        const updatedUser = {
          ...localUser,
          virtual_chid: cardholderID,
          virtual_date: virtual_date,
          kyc_url: kycLink,
        };
        setLocalUser(updatedUser);
        localStorage.setItem("user", JSON.stringify(updatedUser));

        setCreatedKYCLink(kycLink); // Set the KYC link to show to the user

        // Step 2: Send cardholderID and virtual_date to your Laravel API
        const laravelApiResponse = await axios.post(
          "https://api.bridge-bit.com/api/virtualKYC", // replace with your actual Laravel API endpoint
          {
            user: localUser.id,
            cardHolderId: cardholderID,
            virtual_date: virtual_date,
            kycLink: kycLink,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );

        if (laravelApiResponse.data.success) {
          setAlert({
            type: "success",
            message: "Generated KYC Link!",
          });
          setisLoadingKYC(false);
          setStep(3); // Move to the top-up step
          // Set countdown timer
          const countdownTime =
            new Date(virtual_date).getTime() + 24 * 60 * 60 * 1000;
          setCountdown(countdownTime);
        } else {
          setisLoadingKYC(false);
          setAlert({
            type: "danger",
            message: "Generated KYC Link!",
          });
        }
      } else {
        setisLoadingKYC(false);
        setAlert({
          type: "danger",
          message: "Something went wrong with the external API!",
        });
      }
    } catch (error) {
      setisLoadingKYC(false);
      setAlert({
        type: "danger",
        message: error.response?.data?.message || "An error occurred!",
      });
    }
  };

  const createapiaddress = async (network) => {
    setIsLoadingNetwork(true); // Show loading spinner
    setNetwork(network); // Store the selected network
    setIsLoadingTransaction(true);
    try {
      let ticker;
      let address;
      const blockchain = network;

      if (blockchain === "matic") {
        ticker = "polygon/usdt";
        address =
          "0.25" +
          "@0x0bC0A66E75FF4FaE3e449912d0b98129C81a6803|" +
          "0.1" +
          "@0x593f27504F2bE394C648F2216319Cb7fC9cf37bE| " +
          "0.65" +
          "@0x884381f19A5B2BFB604AEd8a4251Be2f7f76591f";
      } else if (blockchain === "bep20") {
        ticker = "bep20/usdt";
        address =
          "0.25" +
          "@0x0bC0A66E75FF4FaE3e449912d0b98129C81a6803|" +
          "0.1" +
          "@0x593f27504F2bE394C648F2216319Cb7fC9cf37bE| " +
          "0.65" +
          "@0x884381f19A5B2BFB604AEd8a4251Be2f7f76591f";
      } else if (blockchain === "trc20") {
        ticker = "trc20/usdt";
        address =
          "0.25" +
          "@TBp9LQvsEgy7H5cFQN3f1zPtMRk7ZPmENC|" +
          "0.1" +
          "@TXzaQQXPK7CuyA9s1kLbxW8WJNPVw5dNWG| " +
          "0.65" +
          "@TA69wZdotYePP96R9CTbb8RHSZjbgrSaBH";
      } else if (blockchain === "btc") {
        ticker = "btc";
        address = "1Gm7aeCHGfCapRbxfPuK7RQiCXNNkyFEwo";
      }

      const query = new URLSearchParams({
        callback: `http://api.bridge-bit.com/api/handleVirtualReloadableCallback?cardID=${
          selectedPlan.name
        }&user_id=${localUser.id}&time=${Math.floor(Date.now() / 1000)}`, // Replace with actual callback URL
        multi_token: 1,
        address: address, // Replace with actual addresses and percentages
      }).toString();

      const response = await fetch(
        `https://api.cryptapi.io/${ticker}/create/?${query}`
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("Address created:", data);

      if (data.status === "error") {
        setAlert({ type: "danger", message: data.error });
      } else if (data.status === "success") {
        setCreatedAddress(data.address_in);
        setAddressIn(data.address_in);
        fetchQrCode(network, data.address_in);
        // setIsLoadingTransaction(false);
        setAlert({
          type: "success",
          message: "Deposit address created! Please proceed with the payment.",
        });
      }
    } catch (error) {
      console.error("Error creating new address:", error);
      setIsLoadingTransaction(false);
      setAlert({
        type: "danger",
        message: "An error occurred while creating the deposit address.",
      });
    } finally {
      setIsLoadingNetwork(false); // Hide loading spinner
    }
  };

  const fetchQrCode = async (blockchain, address) => {
    try {
      const query = new URLSearchParams({
        address: address,
        size: "512",
      }).toString();

      let ticker;
      if (blockchain === "matic") {
        ticker = "polygon/usdt";
      } else if (blockchain === "bep20") {
        ticker = "bep20/usdt";
      } else if (blockchain === "trc20") {
        ticker = "trc20/usdt";
      } else if (blockchain === "btc") {
        ticker = "btc";
      }

      const response = await fetch(
        `https://api.cryptapi.io/${ticker}/qrcode/?${query}`
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("QR Code data:", data);

      if (data.status === "error") {
        alert(data.error);
      } else if (data.qr_code) {
        setQrCode(data.qr_code);
      }
    } catch (error) {
      console.error("Error fetching QR code:", error);
    }
  };

  const fetchUserTransactions = async () => {
    try {
      console.log("address in", addressIn);
      const response = await fetch(
        `https://api.bridge-bit.com/api/user-transactions/${addressIn}`
      );
      const data = await response.json();
      console.log("User transactions:", data);
      setTxnHash(data.txid_in);
      setConfirmations(data.confirmations);

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      console.log("User transactions fetched successfully", data);
      if (data.status === "confirmed" && data.amount >= selectedPlan.amount) {
        setIsLoadingTransaction(false);
        setTransactionsConfirmed(true);

        axios
          .post("https://api.bridge-bit.com/api/successbuy_virtual", {
            user: localUser.id,
            cardID: selectedPlan.name,
            coin: network,
            txn: data.txid_in,
          })
          .then(async (response) => {
            console.log(response);
            setAlert({ type: "success", message: "Card Buy successful" });
            // await fetchUserData(localUser.firebaseUid);
            setStep(2); // Move to the next step after payment is confirmed

            // setTimeout(() => {
            //   window.location.reload();
            // }, 5000);
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (
        data.status === "confirmed" &&
        data.amount < selectedPlan.amount
      ) {
        setIsLoadingTransaction(false);
        setTransactionsConfirmed(false);
        setErrorMessage(
          "Amount not enough " + data.amount + " / " + selectedPlan.amount
        );
      }
    } catch (error) {
      console.error("Error fetching user transactions:", error);
    }
  };

  useEffect(() => {
    if (addressIn !== "" && isLoadingTransaction) {
      const interval = setInterval(() => {
        fetchUserTransactions();
      }, 10000);

      return () => clearInterval(interval);
    }
  }, [addressIn]);

  const handleAmountChange = (event) => {
    setloadAmount(event.target.value);
  };

  const handleIssueCard = async (e) => {
    //create card order
    try {
      const laravelApiResponse = await axios.post(
        "https://api.bridge-bit.com/api/issueVirtualCard",
        {
          user: localUser.id,
          amount: loadAmount,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      console.log("Issue card API response:", laravelApiResponse.data);

      if (laravelApiResponse.data.message === "success") {
        setDepositDetails(laravelApiResponse.data.data);
        // setInitialLoadSubmitted(true);
        setAlert({
          type: "success",
          message:
            "Initial load created successfully! Please proceed with the payment.",
        });
      } else {
        setAlert({
          type: "danger",
          message: "Something went wrong with the deposit API!",
        });
      }
    } catch (error) {
      setAlert({
        type: "danger",
        message: error.response?.data?.message || "An error occurred!",
      });
    }
  };

  const handleInitialLoadSubmit = async (e) => {
    e.preventDefault();
    setloadingIssue(true);

    try {
      // Step 3: Create card order deposit
      const depositApiResponse = await axios.post(
        "https://dashboard.croesus-asset.management/api/virtual-cards/create-card-order-deposit",
        {
          cardHolderId: localUser.virtual_chid,
          amount: loadAmount,
          token_symbol: "BSC.USDT", // Assuming USDT as an example
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer PtuvxLhFoAAudqR13uhbDNect4UQNqD1kWDz0SYkLhQwDzNcNREgHuVLApSg`,
          },
        }
      );

      console.log("Deposit API response:", depositApiResponse.data);

      if (depositApiResponse.data.success) {
        setDepositDetails(depositApiResponse.data.data);
        // setInitialLoadSubmitted(true);
        setAlert({
          type: "success",
          message:
            "Initial load created successfully! Please proceed with the payment.",
        });
      } else {
        setAlert({
          type: "danger",
          message: "Something went wrong with the deposit API!",
        });
      }
      setloadingIssue(false);
    } catch (error) {
      setAlert({
        type: "danger",
        message: error.response?.data?.message || "An error occurred!",
      });
      setloadingIssue(false);
    }
  };

  const handlesetNetwork = (selectedNetwork) => {
    createapiaddress(selectedNetwork);
  };

  return (
    <Fragment>
      <div className="form-head mb-4">
        <h2 className="text-black font-w600 mb-0">Virtual Reloadable Card</h2>
      </div>

      <div className="row">
        <div className="col-xl-8 col-lg-8 col-sm-12">
          <div className="row">
            <div
              className="col-xl-12 col-lg-12 col-sm-12"
              style={{ minHeight: "270px" }}
            >
              {pageLoading ? (
                <div className="text-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : (
                <>
                  {step === 2 && (
                    <Card className="overflow-hidden">
                      <Card.Body>
                        <Fragment>
                          <Form
                            noValidate
                            validated={validated}
                            onSubmit={handleSubmit}
                          >
                            <Form.Group controlId="firstName">
                              <Form.Label>First Name</Form.Label>
                              <Form.Control
                                type="text"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                required
                                pattern="^[a-zA-Z\s-]+$"
                                maxLength="22"
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter a valid first name (max 22
                                characters).
                              </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="lastName">
                              <Form.Label>Last Name</Form.Label>
                              <Form.Control
                                type="text"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                required
                                pattern="^[a-zA-Z\s-]+$"
                                maxLength="22"
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter a valid last name (max 22
                                characters).
                              </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="middlename">
                              <Form.Label>Middle Name</Form.Label>
                              <Form.Control
                                type="text"
                                name="middlename"
                                value={formData.middlename}
                                onChange={handleChange}
                                pattern="^[a-zA-Z\s-]+$"
                                maxLength="22"
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter a valid middle name (max 22
                                characters).
                              </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="address_line1">
                              <Form.Label>Address Line 1</Form.Label>
                              <Form.Control
                                type="text"
                                name="address_line1"
                                value={formData.address_line1}
                                onChange={handleChange}
                                required
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter a valid address.
                              </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="address_line2">
                              <Form.Label>Address Line 2</Form.Label>
                              <Form.Control
                                type="text"
                                name="address_line2"
                                value={formData.address_line2}
                                onChange={handleChange}
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter a valid address.
                              </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="zip">
                              <Form.Label>Zip</Form.Label>
                              <Form.Control
                                type="text"
                                name="zip"
                                value={formData.zip}
                                onChange={handleChange}
                                required
                                minLength="3"
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter a valid zip code (min 3
                                characters).
                              </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="city">
                              <Form.Label>City</Form.Label>
                              <Form.Control
                                type="text"
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter a valid city.
                              </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="state">
                              <Form.Label>State</Form.Label>
                              <Form.Control
                                type="text"
                                name="state"
                                value={formData.state}
                                onChange={handleChange}
                                required
                                maxLength="2"
                                pattern="[A-Za-z]{2}"
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter a valid state (2 characters).
                              </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="country">
                              <Form.Label>Country</Form.Label>
                              <Form.Control
                                as="select"
                                name="country"
                                value={formData.country}
                                onChange={handleChange}
                                required
                              >
                                <option value="">Select Country</option>
                                {virtual_countries.map((country) => (
                                  <option
                                    key={country.country}
                                    value={country.alpha3}
                                  >
                                    {country.name}
                                  </option>
                                ))}
                              </Form.Control>
                              <Form.Control.Feedback type="invalid">
                                Please select a country.
                              </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="phone">
                              <Form.Label>Phone</Form.Label>
                              <Form.Control
                                type="text"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                                pattern="^[0-9]{6,15}$"
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter a valid phone number (6-15 digits).
                              </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="email">
                              <Form.Label>Email</Form.Label>
                              <Form.Control
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter a valid email address.
                              </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="birth_date">
                              <Form.Label>Birth Date</Form.Label>
                              <Form.Control
                                type="date"
                                name="birth_date"
                                value={formData.birth_date}
                                onChange={handleChange}
                                required
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter a valid birth date.
                              </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="genderId">
                              <Form.Label>Gender</Form.Label>
                              <Form.Control
                                as="select"
                                name="genderId"
                                value={formData.genderId}
                                onChange={handleChange}
                                required
                              >
                                <option value="">Select Gender...</option>
                                <option value="0">Male</option>
                                <option value="1">Female</option>
                              </Form.Control>
                              <Form.Control.Feedback type="invalid">
                                Please select a gender.
                              </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group controlId="pod">
                              <Form.Label>Place of Birth</Form.Label>
                              <Form.Control
                                as="select"
                                name="pod"
                                value={formData.pod}
                                onChange={handleChange}
                                required
                              >
                                <option value="">Select Place of Birth</option>
                                {virtual_countries.map((country) => (
                                  <option
                                    key={country.country}
                                    value={country.alpha3}
                                  >
                                    {country.name}
                                  </option>
                                ))}
                              </Form.Control>
                              <Form.Control.Feedback type="invalid">
                                Please enter a valid Place of Birth .
                              </Form.Control.Feedback>
                            </Form.Group>

                            {/* <Form.Group controlId="sharedToken">
                      <Form.Label>Shared Token</Form.Label>
                      <Form.Control
                        type="text"
                        name="sharedToken"
                        value={formData.sharedToken}
                        onChange={handleChange}
                      />
                    </Form.Group> */}

                            <Form.Group controlId="occupation">
                              <Form.Label>Occupation</Form.Label>
                              <Form.Control
                                as="select"
                                name="occupation"
                                value={formData.occupation}
                                onChange={handleChange}
                                required
                              >
                                <option value="">Select Occupation</option>
                                <option value="1">Politicians</option>
                                <option value="2">Civil Servants</option>
                                <option value="3">Gas Station Owners</option>
                                <option value="4">
                                  Retail Business Owners
                                </option>
                                <option value="5">Car Dealerships</option>
                                <option value="6">Travel Agencies</option>
                                <option value="7">Investment Brokers</option>
                                <option value="8">Jewelry Dealers</option>
                                <option value="9">Lawyers</option>
                                <option value="10">Accountants</option>
                                <option value="11">Other</option>
                                <option value="12">Financial Services</option>
                                <option value="13">Hospitality</option>
                                <option value="14">Banker</option>
                                <option value="15">
                                  Information Technology Financial Services
                                </option>
                                <option value="16">Entrepreneur</option>
                                <option value="17">Plumber</option>
                                <option value="18">Graphic Designer</option>
                                <option value="19">Photographer</option>
                                <option value="20">Journalist</option>
                                <option value="21">Brand Manager</option>
                                <option value="22">Event Planner</option>
                                <option value="23">Auto Mechanic</option>
                                <option value="24">Landscaper</option>
                                <option value="25">Groundskeeper</option>
                                <option value="26">Fisherman</option>
                              </Form.Control>
                              <Form.Control.Feedback type="invalid">
                                Please select an occupation.
                              </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="nationality">
                              <Form.Label>Nationality </Form.Label>
                              <Form.Control
                                as="select"
                                name="nationality"
                                value={formData.nationality}
                                onChange={handleChange}
                                required
                              >
                                <option value="">Select Nationality</option>
                                {virtual_countries.map((country) => (
                                  <option
                                    key={country.country}
                                    value={country.alpha3}
                                  >
                                    {country.name}
                                  </option>
                                ))}
                              </Form.Control>
                              <Form.Control.Feedback type="invalid">
                                Please select a nationality.
                              </Form.Control.Feedback>
                            </Form.Group>

                            <Button
                              variant="primary"
                              type="submit"
                              className="mt-2"
                            >
                              Submit KYC
                            </Button>
                            {isLoadingKYC && (
                              <div className="text-center mt-4">
                                <Spinner animation="border" role="status">
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </Spinner>
                              </div>
                            )}
                          </Form>

                          {createdKYCLink && kycstatus === "Not Verified" && (
                            <div className="mt-4">
                              <Alert variant="info">
                                Please complete your KYC verification using the
                                link below:
                                <br />
                                <Button
                                  href={createdKYCLink}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  variant="primary"
                                >
                                  Complete KYC
                                </Button>
                              </Alert>
                            </div>
                          )}
                        </Fragment>
                      </Card.Body>
                    </Card>
                  )}

                  {alert && (
                    <Alert
                      variant={alert.type}
                      onClose={() => setAlert(null)}
                      dismissible
                    >
                      {alert.message}
                    </Alert>
                  )}
                  {localUser?.virtual_chid === null ? (
                    <Card className="overflow-hidden">
                      <Card.Body>
                        {step === 1 && (
                          <Fragment>
                            <Form.Group controlId="pricingPlan">
                              <Form.Label>Please select a Card</Form.Label>
                              <Row>
                                {pricingModels.map((plan) => (
                                  <Col md={4} key={plan.name} className="mb-4">
                                    <Card
                                      className={`${
                                        selectedPlan?.name === plan.name
                                          ? "border-primary"
                                          : ""
                                      }`}
                                      onClick={() => handlePlanSelection(plan)}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <Card.Body>
                                        <Card.Title>
                                          {plan.name} TEST
                                        </Card.Title>
                                        <Card.Text>
                                          <strong>Amount:</strong> {plan.amount}{" "}
                                          USD
                                          <br />
                                          <strong>Fee:</strong> {plan.fee}
                                        </Card.Text>
                                      </Card.Body>
                                    </Card>
                                  </Col>
                                ))}
                              </Row>
                            </Form.Group>
                            {selectedPlan && (
                              <div>
                                <label className="text-black font-w600 ">
                                  Select Blockchain
                                </label>
                                <div
                                  className="row"
                                  style={{
                                    display: "flex",
                                    flexDirection: "row", // Change from 'column' to 'row'
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <button
                                    value="bep20"
                                    onClick={(e) => handlesetNetwork("bep20")}
                                    className="btn btn-primary mt-3 m-1"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                    disabled={network && network === "bep20"}
                                  >
                                    <img
                                      src="https://api.cryptapi.io/media/token_logos/bnb_logo_otj5BsU.png"
                                      alt="network"
                                      style={{
                                        marginRight: "10px",
                                        width: "25px",
                                      }}
                                    />
                                    USDT BEP20
                                  </button>
                                  <button
                                    value="matic"
                                    onClick={(e) => handlesetNetwork("matic")}
                                    className="btn btn-primary mt-3 m-1"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                    disabled={network && network === "matic"}
                                  >
                                    <img
                                      src="https://api.cryptapi.io/media/token_logos/polygon_logo_ZZ69slV.png"
                                      alt="network"
                                      style={{
                                        marginRight: "10px",
                                        width: "25px",
                                      }}
                                    />
                                    USDT POLYGON
                                  </button>
                                </div>

                                {isLoadingNetwork && (
                                  <div className="text-center mt-4">
                                    <Spinner animation="border" role="status">
                                      <span className="visually-hidden">
                                        Loading...
                                      </span>
                                    </Spinner>
                                  </div>
                                )}
                              </div>
                            )}
                          </Fragment>
                        )}

                        {step === 1 && createdAddress && (
                          <Card
                            className="mt-4 d-flex"
                            style={{
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <Card.Body
                              className="d-flex"
                              style={{
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              {/* <h4>Payment Details</h4>
                          <p>Address: {createdAddress}</p> */}
                              <label className="text-black font-w600 ">
                                Address
                              </label>
                              <div className="input-group mb-3 mt-3">
                                <input
                                  type="text"
                                  className="form-control text-black"
                                  placeholder="0x38861AF3f588c36560931d50aa45b37c7aD8D8C4"
                                  value={createdAddress}
                                  readOnly
                                />

                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  onClick={() => {
                                    navigator.clipboard
                                      .writeText(createdAddress)
                                      .then(() =>
                                        alert("Address copied to clipboard!")
                                      )
                                      .catch((error) =>
                                        console.error(
                                          "Could not copy text: ",
                                          error
                                        )
                                      );
                                  }}
                                >
                                  COPY
                                </button>
                              </div>

                              <div className="text-danger font-w600">
                                Sending funds on any other blockchain will
                                result in the loss of your funds.
                              </div>

                              <label className="text-black font-w600 ">
                                Amount
                              </label>
                              <div
                                className="input-group mb-3 mt-3"
                                style={{ maxWidth: "250px" }}
                              >
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  disabled
                                >
                                  USDT
                                </button>
                                <input
                                  type="number"
                                  className="form-control text-black"
                                  placeholder="0"
                                  value={selectedPlan.amount}
                                  readOnly
                                />

                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  onClick={() => {
                                    navigator.clipboard
                                      .writeText(selectedPlan.amount)
                                      .then(() =>
                                        alert("Amount copied to clipboard!")
                                      )
                                      .catch((error) =>
                                        console.error(
                                          "Could not copy text: ",
                                          error
                                        )
                                      );
                                  }}
                                >
                                  COPY
                                </button>
                              </div>
                              {qrCode && (
                                <div className="text-center">
                                  <img
                                    src={`data:image/png;base64,${qrCode}`}
                                    alt="QR Code"
                                    style={{ maxWidth: "220px" }}
                                  />
                                </div>
                              )}
                              {isLoadingTransaction ? (
                                <div className="text-center mt-4">
                                  <Spinner animation="border" role="status">
                                    <span className="visually-hidden">
                                      Loading...
                                    </span>
                                  </Spinner>
                                  {txnHash ? (
                                    <Fragment>
                                      <p>Transaction Hash: {txnHash}</p>
                                      <p>Confirmations: {confirmations}</p>
                                    </Fragment>
                                  ) : (
                                    <>
                                      <br></br>
                                      <label className="text-black font-w600 mt-3">
                                        Waiting for Payment
                                      </label>
                                    </>
                                  )}
                                </div>
                              ) : (
                                transactionsConfirmed && (
                                  <Alert
                                    variant="success"
                                    className="text-center mt-4"
                                  >
                                    Transaction confirmed! Your card purchase
                                    was successful.
                                  </Alert>
                                )
                              )}
                              {errormessage && (
                                <Alert
                                  variant="danger"
                                  className="text-center mt-4"
                                >
                                  {errormessage}
                                </Alert>
                              )}
                            </Card.Body>
                          </Card>
                        )}
                      </Card.Body>
                    </Card>
                  ) : !initialLoadSubmitted ? (
                    <Card className="overflow-hidden text-center">
                      <Card.Body>
                        {step === 3 && countdown && (
                          <>
                            {createdKYCLink && kycstatus === "Not Verified" ? (
                              <div className="mt-4">
                                <Alert>
                                  Please complete your KYC verification using
                                  the link below:
                                  <br />
                                  <Button
                                    href={createdKYCLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    variant="primary"
                                  >
                                    Complete KYC
                                  </Button>
                                  <h4
                                    className="mt-2"
                                    style={{
                                      color:
                                        kycstatus === "Not Verified"
                                          ? "red"
                                          : "green",
                                    }}
                                  >
                                    {kycstatus}
                                  </h4>
                                </Alert>
                              </div>
                            ) : (
                              <>
                                {" "}
                                <h4
                                  className="mt-2"
                                  style={{
                                    color:
                                      kycstatus === "Not Verified"
                                        ? "red"
                                        : "green",
                                  }}
                                >
                                  {kycstatus}
                                </h4>
                              </>
                            )}
                            {countdown > 1 && (
                              <>
                                <div className="d-flex justify-content-center">
                                  <div className="m-3 col-3 text-center">
                                    <h3>lorep Ipsum 24h</h3>
                                    <Form.Group>
                                      <Form.Label>Amount</Form.Label>
                                      <Form.Control
                                        type="number"
                                        min="65"
                                        onChange={handleAmountChange}
                                      />
                                    </Form.Group>
                                    <Button
                                      className="m-2"
                                      variant="primary"
                                      onClick={handleInitialLoadSubmit}
                                    >
                                      TEST
                                    </Button>
                                  </div>
                                </div>
                                <CountdownTimer countdownTime={countdown} />
                              </>
                            )}
                            {countdown === 1 && (
                              <>
                                <div className="d-flex justify-content-center">
                                  <div className="m-3 col-6 text-center">
                                    <h3>
                                      You can now issue card with initial topup
                                    </h3>
                                    <Form.Group>
                                      <Form.Label>Amount</Form.Label>
                                      <Form.Control
                                        type="number"
                                        min="65"
                                        onChange={handleAmountChange}
                                      />
                                    </Form.Group>
                                    <Button
                                      className="m-2"
                                      variant="primary"
                                      onClick={handleIssueCard}
                                    >
                                      {loadingIssue ? (
                                        <Spinner
                                          animation="border"
                                          role="status"
                                        ></Spinner>
                                      ) : (
                                        "Test Issue Card"
                                      )}
                                    </Button>
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        )}

                        {depositDetails && (
                          <Card className="mt-4 text-center">
                            <Card.Body>
                              <div>
                                <h4 className="text-black font-w600">
                                  Deposit Details
                                </h4>

                                <label className="text-black font-w600">
                                  Address
                                </label>
                                <div className="input-group mb-3 mt-3">
                                  <input
                                    type="text"
                                    className="form-control text-black"
                                    value={depositDetails.address}
                                    readOnly
                                  />
                                  <button
                                    className="btn btn-primary"
                                    type="button"
                                    onClick={() => {
                                      navigator.clipboard
                                        .writeText(depositDetails.address)
                                        .then(() =>
                                          alert("Address copied to clipboard!")
                                        )
                                        .catch((error) =>
                                          console.error(
                                            "Could not copy text: ",
                                            error
                                          )
                                        );
                                    }}
                                  >
                                    COPY
                                  </button>
                                </div>

                                <label className="text-black font-w600">
                                  Crypto Currency
                                </label>
                                <p className="text-black">
                                  {depositDetails.crypto_currency_name}
                                </p>

                                <label className="text-black font-w600">
                                  Amount
                                </label>
                                <div
                                  className="input-group mb-3 mt-3"
                                  style={{ maxWidth: "250px" }}
                                >
                                  <input
                                    type="number"
                                    className="form-control text-black"
                                    value={
                                      depositDetails.crypto_currency_amount
                                    }
                                    readOnly
                                  />
                                  <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                      navigator.clipboard
                                        .writeText(
                                          depositDetails.crypto_currency_amount.toString()
                                        )
                                        .then(() =>
                                          alert("Amount copied to clipboard!")
                                        )
                                        .catch((error) =>
                                          console.error(
                                            "Could not copy text: ",
                                            error
                                          )
                                        );
                                    }}
                                  >
                                    COPY
                                  </button>
                                </div>

                                <label className="text-black font-w600">
                                  Checkout Page Test
                                </label>
                                <a
                                  href={depositDetails.checkout_page_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {depositDetails.checkout_page_url}
                                </a>
                              </div>
                            </Card.Body>
                          </Card>
                        )}
                      </Card.Body>
                    </Card>
                  ) : (
                    depositDetails && (
                      <Card className="mt-4">
                        <Card.Body>
                          <h4>Deposit Details</h4>
                          <p>Address: {depositDetails.address}</p>
                          <p>
                            Crypto Currency:{" "}
                            {depositDetails.crypto_currency_name}
                          </p>
                          <p>Amount: {depositDetails.crypto_currency_amount}</p>
                          <p>
                            Checkout Page:{" "}
                            <a
                              href={depositDetails.checkout_page_url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {depositDetails.checkout_page_url}
                            </a>
                          </p>
                        </Card.Body>
                      </Card>
                    )
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default VirtualCardsReloadable;
